import dayjs from 'dayjs'

export const formatReleaseDate = (date: string | null) => {
    const dayjsDate = dayjs.utc(date)
    if (dayjsDate.isValid()) {
        return dayjsDate.format('MM/DD/YYYY')
    }

    return undefined
}
